import { ERROR } from "../config/action-states";
import { ROUTES } from "../routes";
import AuthService from "../services/auth-service";
import UserService from "../services/user-service";
import { clearCachedUser } from "../store/current-user";
import logger from "./logger";

interface ILogoutArgs {
  redirectTo?: string;
  onLogoutSuccess?: () => void;
}

export async function logout({ redirectTo = ROUTES.HOME, onLogoutSuccess }: ILogoutArgs) {
  try {
    const response = await UserService.logout();

    if(!(ERROR in response)) {
      AuthService.deleteAccessToken();
      clearCachedUser();

      if(typeof onLogoutSuccess === "function") {
        onLogoutSuccess();
      }

      if(redirectTo) {
        window.location.href = redirectTo;
      }
    }
  } catch(error) {
    logger.error("Error logging user out: ", error);
    window.location.href = location.href; // just reload if logout fails
  }
}
